import { z } from 'zod';

// Form validation schema mapping directly back to DOVSInitiationPayload
export const dovsSchema = z.object({
    id_number: z.string({ error: 'ID Number is required' })
        .length(13, 'South African ID must be 13 digits')
        .regex(/^\d+$/, 'ID must be numeric')
        .min(1, 'ID Number is required'),
    cell_number: z.string({ error: 'Cell Number is required' })
        .length(10, 'Cell Number must be 10 digits')
        .regex(/^\d+$/, 'Cell Number must be numeric')
        .min(1, 'Cell Number is required'),
    your_reference: z.string().optional().or(z.literal('')),
    voucher_code: z.string().optional().or(z.literal(''))
});

export type DOVSInitiationPayload = z.infer<typeof dovsSchema>;

export interface DOVSInitiationResponse {
    message: string;
    success: boolean;
    request_id: string;
    enquiry_id: string;
}

export interface DOVSResultResponse {
    message: string;
    success: boolean;
    status: 'AWAITING_VERIFICATION' | 'COMPLETED' | 'FAILED';
    report_data: any;
}

const BASE_URL = '/verification/dovs';

export const dovsService = {
    // Phase 1: Initiates matching and sends SMS
    initiateDOVS: async (payload: DOVSInitiationPayload): Promise<DOVSInitiationResponse> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.post<DOVSInitiationResponse>(`${BASE_URL}/initiate`, payload);
        return response.data;
    },

    // Phase 2: Polls XDS periodically for outcome
    checkDOVSResult: async (requestId: string): Promise<DOVSResultResponse> => {
        const axios = (await import('../axiosConfig')).default;
        const response = await axios.get<DOVSResultResponse>(`${BASE_URL}/${requestId}/result`);
        return response.data;
    }
};
